import partners from "./../Partners/partners.css";
import Create from "../Create/Create";
import Trust from "../Trust/Trust";
import videoimg from "../../assets/videoimg.png";
import CountUp from "react-countup";
const Partners = () => {
  const stats = [
    {
      id: 1,
      value: 75000,
      startValue: 20000,
      suffix: "+",
      label: "Taps every month",
      minWidth: "300px",
    },
    {
      id: 2,
      value: 8200,
      startValue: 2000,
      suffix: "+",
      label: "Repeat Clients",
      minWidth: "260px",
    },
    {
      id: 3,
      value: 120,
      startValue: 20,
      suffix: "+",
      label: "Corporate Partners",
      minWidth: "170px",
    },
    {
      id: 4,
      value: 4,
      startValue: 0,
      suffix: "M+",
      label: "Contact Shared",
      minWidth: "150px",
    },
  ];

  return (
    <div className="MainPartnersContainer">
      <div className="PartnersContainer">
        <div className="PartnersWrapper">
          {stats?.map((stat) => (
            <div key={stat.id}>
              <h3
                style={{ minWidth: stat.minWidth }}
                className="partnersCounth3"
              >
                <CountUp
                  start={stat.startValue}
                  end={stat.value}
                  duration={2}
                  separator=","
                  suffix={stat?.suffix || ""}
                  enableScrollSpy
                  scrollSpyOnce
                />
              </h3>
              <p>{stat?.label || ""}</p>
            </div>
          ))}
        </div>

        {/* <div className="CardWrapper">
          <div className="Card">
            <div>
              <div className="CardTextWrapper">
                <h4>
                  Upgrade to NFC Cards for <span>Instant Sharing</span> and{" "}
                  <span>Zero</span> Paper Waste
                </h4>
                <p>
                  <span>88%</span> of Paper of Cards End up in Dustbins{" "}
                  <span className="arrow">
                    {" "}
                    <i className="fa-solid fa-arrow-right"></i>{" "}
                  </span>{" "}
                  Save Every Lead with NFC Cards{" "}
                </p>
              </div>
              <div className="TextVideoWrapper">
                <div className="VideoText">
                  smart, fast, and Sustainable Connection with NFC
                </div>
                <div className="VideoWrapper">
                  <a href="" rel="noopener noreferrer" target="_blank" ><img src={videoimg} alt="" /></a>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Partners;
